import { defineComponent, reactive, ref } from "vue";
export default defineComponent({
  name: "headNav",
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var navHead = reactive(["新歌速递", "新碟上架"]);
    var isHead = ref("新歌速递");
    /* 导航点击切换颜色 */

    var navHeadClick = function navHeadClick(item) {
      isHead.value = item;
      emit("navChange", item);
    };

    return {
      isHead: isHead,
      navHead: navHead,
      navHeadClick: navHeadClick
    };
  },
  components: {}
});